// import { ICanvasEditorState } from "../../widgets/interfaces/model/CanvasEditorState";
import { ISelection } from "../../widgets/interfaces/model/index";
import { createReducers } from "../util";
import {
	adjustHighlight,
	clearSubgroupSelection,
	deleteAspectRatio,
	deselectAllObjects,
	deselectObject,
	selectObject,
	selectObjectsByIndex,
	selectPage,
	setAllAspectRatios,
	setAllTextDefaultStyles,
	setAspectRatio,
	setFirstCharStyle,
	setFormatPainterTextStyles,
	setImpossiblePaths,
	setShapeDefaultProperties,
	setShapeDrawMetadata,
	setShapeDrawTool,
	setTextDefaultStyles,
	setTextEditorInstance,
	setTextShapeDefaultProperties,
} from "./SelectionOperations";

/**
 * Default state for selection
 */
const initialState: ISelection = {
	aspectRatioMap: {},
	formatPainterTextStyles: undefined,
	groupSelectionIndices: [],
	selectedPage: undefined,
	selectedPageObjects: [],
	shapeFirstCharStyles: undefined,
	textEditorInstance: [],
};

/**
 * Action constants for selection operations
 */
export enum SelectionConstants {
    ADJUST_HIGHLIGHT = "ADJUST_HIGHLIGHT",
    CLEAR_SUBGROUP_SELECTION = "CLEAR_SUBGROUP_SELECTION",
    DEFAULT_HIGHLIGHT_BLUE = "2px dashed var(--PrimaryBlue)",
    DEFAULT_HIGHLIGHT_GREY = "2px dashed var(--Grey700)",
    DEFAULT_HIGHLIGHT_RED = "2px dashed var(--Red700)",
    DELETE_ASPECT_RATIO = "DELETE_ASPECT_RATIO",
    DESELECT_OBJECT = "DESELECT_OBJECT",
    DESELECT_ALL_OBJECTS = "DESELECT_ALL_OBJECTS",
    HIGHLIGHT_COLOR = "#2d76d4",
    IMPOSSIBLE_PATHS = "IMPOSSIBLE_PATHS",
    IMAGE_PLACEHOLDER = "ImagePlaceholder",
    LOCKED_HIGHLIGHT_COLOR = "red",
    PRIMARY_BLUE = "var(--PrimaryBlue)",
    PRIMARY_GREY = "var(--Grey700)",
    PRIMARY_RED = "var(--Red700)",
    SELECT_PAGE = "SELECT_PAGE",
    SELECT_OBJECT = "SELECT_OBJECT",
    SET_ALL_ASPECT_RATIOS = "SET_ALL_ASPECT_RATIOS",
    SET_ALL_TEXT_DEFAULTS_STYLES = "SET_ALL_TEXT_DEFAULTS_STYLES",
    SET_ASPECT_RATIO = "SET_ASPECT_RATIO",
    SET_FIRST_CHAR_STYLE = "SET_FIRST_CHAR_STYLE",
    SET_FORMAT_PAINTER_TEXT_STYLE = "SET_FORMAT_PAINTER_TEXT_STYLE",
    SET_MATRIX = "SET_MATRIX",
    SET_SHAPE_TOOL = "SET_SHAPE_TOOL",
    SET_SHAPE_METADATA = "SET_SHAPE_METADATA",
    SET_SHAPE_DEFAULT_PROPERTIES = "SET_SHAPE_DEFAULT_PROPERTIES",
    SET_TEXT_DEFAULT_STYLES = "SET_TEXT_DEFAULT_STYLES",
    SET_TEXT_EDITOR_INSTANCE = "SET_TEXT_EDITOR_INSTANCE",
    SET_TEXT_SHAPE_DEFAULT_PROPERTIES = "SET_TEXT_SHAPE_DEFAULT_PROPERTIES",
    STORE_OBJECT_SELECTIONS = "STORE_OBJECT_SELECTIONS",
    STROKE = "stroke",
}

/**
 * Selection reducers
 */
export const selectionState = createReducers(initialState, {
	[SelectionConstants.ADJUST_HIGHLIGHT]: adjustHighlight,
	[SelectionConstants.SELECT_PAGE]: selectPage,
	[SelectionConstants.SELECT_OBJECT]: selectObject,
	[SelectionConstants.CLEAR_SUBGROUP_SELECTION]: clearSubgroupSelection,
	[SelectionConstants.DESELECT_OBJECT]: deselectObject,
	[SelectionConstants.DESELECT_ALL_OBJECTS]: deselectAllObjects,
	[SelectionConstants.IMPOSSIBLE_PATHS]: setImpossiblePaths,
	[SelectionConstants.STORE_OBJECT_SELECTIONS]: selectObjectsByIndex,
	[SelectionConstants.SET_SHAPE_TOOL]: setShapeDrawTool,
	[SelectionConstants.SET_SHAPE_METADATA]: setShapeDrawMetadata,
	[SelectionConstants.SET_SHAPE_DEFAULT_PROPERTIES]: setShapeDefaultProperties,
	[SelectionConstants.SET_TEXT_EDITOR_INSTANCE]: setTextEditorInstance,
	[SelectionConstants.SET_FIRST_CHAR_STYLE]: setFirstCharStyle,
	[SelectionConstants.SET_FORMAT_PAINTER_TEXT_STYLE]: setFormatPainterTextStyles,
	[SelectionConstants.SET_TEXT_DEFAULT_STYLES]: setTextDefaultStyles,
	[SelectionConstants.SET_TEXT_SHAPE_DEFAULT_PROPERTIES]: setTextShapeDefaultProperties,
	[SelectionConstants.SET_ALL_TEXT_DEFAULTS_STYLES]: setAllTextDefaultStyles,
	[SelectionConstants.SET_ASPECT_RATIO]: setAspectRatio,
	[SelectionConstants.DELETE_ASPECT_RATIO]: deleteAspectRatio,
	[SelectionConstants.SET_ALL_ASPECT_RATIOS]: setAllAspectRatios,
});
